<template>
  <div class="form-group form-md-line-input"
      :class="{'has-error': hasErrors, 'has-success':(!hasErrors && validator.$dirty)}">
    <slot></slot>
    <slot name="label">
      <label v-if="label">{{ label }} {{ hasErrors ? '*' : '' }}</label>
    </slot>
    <span class="help-block" v-if="validator.$error">
      <div class="error" v-for="error in activeErrors">
        {{ getErrorMessage(error.validationKey, error.params) }}
      </div>
    </span>
  </div>
</template>

<script>
  import {extractorMixin} from 'vuelidate-error-extractor'

  export default {
    mixins: [extractorMixin]
  }
</script>



// WEBPACK FOOTER //
// src/utils/metronic-input-template.vue